export default {
  reportParams(state, params) {
    return (state.reportParams = params);
  },
  activeTabName(state, value) {
    return (state.activeTabName = value);
  },
};
